export const WHATSAPP_NUMBER = '5511978747233';
export const CONTACT_PATH = '/contato';
export const PHONE_DISPLAY = '(11) 4858-8429';
export const PHONE_HREF = 'tel:+551148588429';

export function whatsappUrl(text?: string): string {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/lukostecnologia/',
  youtube: 'https://www.youtube.com/@lukos-solucoesemtecnologia8036',
  facebook: 'https://www.facebook.com/lukos.solucoes/?locale=pt_BR',
} as const;

export const BLOG_ARTICLES = {
  erp: '/como-o-erp-da-lukos-tecnologia-pode-transformar-a-gestao-do-seu-posto',
  fidelidade: '/programa-de-fidelidade-lukos',
  ia: '/i-a-aplicada-ao-dia-a-dia-do-posto',
  conciliacao: '/ola-mundo',
} as const;

export { DEFAULT_PAGE_TITLE, titleForPath } from './seo';
